// extracted by mini-css-extract-plugin
module.exports = {"Tip":"Tip_Tip__GKqgu"};